import SettingsBreadcrumb from './SettingsBreadcrumb'

export default SettingsBreadcrumb